window.__tnt || (window.__tnt = {});

(function(w, d) {
    const urlParams = new URLSearchParams(document.location.search);
    const sGiftToken = urlParams.get('gift_token');
    const sAssetId = d.body.dataset.assetUuid;
    const userAlreadyRedeemed = sessionStorage.getItem(`tnt.gift.${sAssetId}`) === 'true';
    const oError = d.getElementById('tnt-gift-wall-error');
    const oRedeemedEl = d.getElementById('tnt-gift-wall-redeemed');
    const oLoggedInMsg = oRedeemedEl.querySelector('.gift-logged-in-message');

    async function tnt_redeemGiftToken(sGiftToken) {
        let csrfToken = Cookies.get('tncms_csrf_token');
        let formData = new FormData();
        formData.append('gift_article_token', sGiftToken);
        if (csrfToken) formData.append('tncms_csrf_token', csrfToken);
        let oResp = await fetch(__tnt.scrubUrl('/tncms/subscription/giftarticle_claim/'), {
            method: 'POST',
            body: formData
        });

        if (oResp.ok) {
            w.sessionStorage.setItem(`tnt.gift.${sAssetId}`, true);
            oRedeemedEl.hidden = false;
            oLoggedInMsg.hidden = false;

        } else {
            oError.hidden = false;
        }
    }

    if (sGiftToken) {
        // If the user is logged in and doesn't have access
        if (__tnt.user.loggedIn) {
            // User has already redeemed this article
            if (userAlreadyRedeemed) {
                oRedeemedEl.hidden = false;
                oLoggedInMsg.hidden = false;

            // Redeem the article for the user in the background
            } else {
                tnt_redeemGiftToken(sGiftToken);
            }

        // If the user is anonymous
        } else {
            // Display links to login or signup
            if (userAlreadyRedeemed) {
                oRedeemedEl.hidden = false;
            } else {
                d.getElementById('tnt-gift-wall-anonymous').hidden = false;
            }
        }
    }
})(window, document);